import React from 'react'
import arrowright from '../../assets/img/arrow-right.png'
import { Col } from 'react-bootstrap'

import moment from 'moment'

import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import { getPartnerLogo } from '../../utils/helper'
import { useParams } from 'react-router-dom'


function Receipt(props) {

const {handleDetails, receipt, key} = props
const {partner} = useParams()
const partnerDetails = JSON.parse(localStorage.getItem('partnerData'))
    return (
        <div>
            <div key={key} className='d-flex' onClick={() => { handleDetails(receipt) }}>
                <div className='align-items-center border-bottom d-flex'>
                    <Col sm={3} xs={3} className='h-100 p-2 col-sm-3 col-3 d-flex align-items-center border-bottom'>
                        <img style={{maxWidth: '80px'}} src={receipt?.facility?.photos?.url ? receipt?.facility?.photos?.url : (partnerDetails?.brand_setting?.logourl && partnerDetails?.brand_setting?.logo) ? partnerDetails?.brand_setting?.logourl : getPartnerLogo(partner) } alt='img' />
                    </Col>
                    <Col sm={8} xs={8} className='ms-2 py-3' >
                        {/* <small>{faciltyData?.facility?.between_streets}</small> */}
                        <div className='text-primary small' >{receipt?.ticket_number}</div>
                        <p className='mb-0 small'>{receipt?.facility?.short_name}</p>
                        <small className='mt-0 small header-s text-secondary'>{moment(receipt?.check_in_datetime).format('ddd, MMMM D, h:mm A')} - {moment(receipt?.checkout_datetime).format('h:mm A')}</small>
                    </Col>
                    <Col sm={1} xs={1} className='py-3' >
                        <img className='w-100' src={arrowright} alt='img' />
                    </Col>
                </div>
            </div>
        </div>
    )
}

Receipt.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    handleDetails: PropTypes.func,
    receipt: PropTypes.object,
    key: PropTypes.string,
}

Receipt.defaulProps = {
    dispatch: noop,
    loader: true,
    handleDetails: noop,
    receipt: EMPTY_OBJECT,
    key: ''
}

function mapStateToProps({ ReceiptsReducer }) {
    return {
        loader: ReceiptsReducer?.loader
    }
}
export default connect(mapStateToProps)(Receipt)